import { ButtonBase, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import Typography from '@mui/material/Typography/Typography';
import { ReactNode } from 'react';
import TooltipHardened from '../TooltipHardened';
import useNavigation from '../../Providers/NavigationProvider';

interface NavItemProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
}

export const NavItem = ({ icon, label, onClick }: NavItemProps): React.JSX.Element => {
  const { isOpen } = useNavigation();

  if (!isOpen) {
    return (
      <TooltipHardened
        tooltip={
          <Typography fontSize={16} fontWeight={700}>
            {label}
          </Typography>
        }
        enterDelay={150}
        leaveDelay={100}
        placement={'right'}
      >
        {/* TODO: IconButton would be semantically more correct here, but its circular shape
            and sizing don't span the full row width. Revisit if the collapsed layout changes. */}
        <ButtonBase
          onClick={onClick}
          sx={{
            width: '100%',
            py: 1,
            display: 'flex',
            justifyContent: 'center',
            color: 'action.active',
            '&:hover': { backgroundColor: 'action.hover' },
          }}
        >
          {icon}
        </ButtonBase>
      </TooltipHardened>
    );
  }

  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton onClick={onClick}>
        <ListItemIcon sx={{ py: 1, pl: 0.5 }}>{icon}</ListItemIcon>
        <ListItemText sx={{ textDecoration: 'none' }}>{label}</ListItemText>
      </ListItemButton>
    </ListItem>
  );
};
